import { render, staticRenderFns } from "./ReportAssistantDialog.vue?vue&type=template&id=13b99bd6&scoped=true"
import script from "./ReportAssistantDialog.vue?vue&type=script&lang=js"
export * from "./ReportAssistantDialog.vue?vue&type=script&lang=js"
import style0 from "./ReportAssistantDialog.vue?vue&type=style&index=0&id=13b99bd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b99bd6",
  null
  
)

export default component.exports